import React from 'react';
export function PinIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.707 9.912l-7.619-7.619a1 1 0 00-1.414 1.414l.817.817-3.4 3.4a5 5 0 00-5.582 1.01l-.219.22a1 1 0 000 1.413l3.864 3.864-4.861 4.862a1 1 0 101.414 1.414l4.864-4.865 3.865 3.865a1 1 0 001.412 0l.221-.22a5 5 0 001.01-5.583l3.4-3.4.816.817a1 1 0 001.414-1.414l-.002.005zm-7.62 7.617L6.471 9.914a3.006 3.006 0 013.7.431l3.491 3.492a3.009 3.009 0 01.425 3.692zm.818-5.277L11.747 9.1 14.9 5.938 18.062 9.1l-3.157 3.152z"
  }));
}